import React from 'react';
import { formatListValue } from '@/shared/components/FormattedListValue';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';

const AddressChange = props => {
  const intl = useIntl();
  const { log } = props;

  const property = formatListValue({ list: 'Medium', id: log.label, intl, log });

  if (log.oldValue.Value === null) {
    return (
      <span>
        {intl.formatMessage(messages.AddedFieldForCommunication, {
          property,
          newValue: log.newValue.Value,
          b: value => <b>{value}</b>,
        })}
      </span>
    );
  }

  if (log.newValue.Value === null) {
    return (
      <span>
        {intl.formatMessage(messages.DeletedFieldForCommunication, {
          property,
          oldValue: log.oldValue.Value,
          b: value => <b>{value}</b>,
        })}
      </span>
    );
  }

  return (
    <span>
      {intl.formatMessage(messages.ChangedFieldForCommunication, {
        property,
        originalValue: log.oldValue.Value,
        currentValue: log.newValue.Value,
        b: value => <b>{value}</b>,
      })}
    </span>
  );
};

export default AddressChange;
